<template>
    <div id="FormShareFast">
        <div class="header">
            <div class="icon-container">
                <i class="md-icon">link</i>
            </div>
            <div class="text-container">
                <div class="title">{{ $t("form.formPublish.linkToYour") }}</div>
                <div class="description">{{ $t("form.formPublish.linkToYourDesc") }}</div>
            </div>
        </div>
        <div class="content">
            <div class="form-group">
                <div class="form-header">
                    <h2>{{ $t("form.formPublish.shareWithLink") }}</h2>
                    <button class="public-form">
                        <i class="icon md-icon">lock_open</i> {{ $t("form.formPublish.publicForm") }}
                    </button>
<!--                    <div class="settings-container">-->
<!--                        <i class="icon settings-icon md-icon">settings</i>-->
<!--                        <span class="settings-text">Ayarlar</span>-->
<!--                    </div>-->

                </div>
                <div class="link-group">
                    <div class="link-input">
                        <i class="icon link-icon md-icon">link</i>
                        <input type="text" :value="formattedUrl" readonly />
                        <i class="icon edit-icon md-icon">edit</i>
                        <i class="icon refresh-icon md-icon">refresh</i>
                    </div>
                    <div class="buttons">
                        <button class="copy-link" @click="coppyUrl">{{ $t("form.formPublish.copyLink") }}</button>
                        <button class="open-new-tab" @click="openInNewTab">{{ $t("form.formPublish.openInNewTab") }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "FormShareFast",
    props: {
        formId: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        isBeta() {
            return window.location.hostname.includes("beta.supsis.live");
        },
        formattedUrl() {
            if (this.isBeta) {
                return `https://form.supsis.ai/form/${this.formId}/${this.siteId}?mode=beta`;
            }
            return `https://form.supsis.ai/form/${this.formId}/${this.siteId}`;
        },

    },
    methods: {
        coppyUrl() {
            const url = this.formattedUrl;
            navigator.clipboard.writeText(url).then(() => {
                this.$message.success(this.$t("form.formPublish.linkCopied"));
            });
        },
        openInNewTab() {
            const url = this.formattedUrl;
            window.open(url, "_blank");
        },
    }
};
</script>

<style lang="scss" scoped>
#FormShareFast {
    display: grid;
    justify-content: center;
    padding: 2rem;
    font-family: 'Roboto', sans-serif;

    .header {
        display: flex;
        align-items: center;
        background-color: #f7f7f7;
        padding: 1rem;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 1.5rem;
        width: 700px;

        .icon-container {
            background-color: #57b966;
            border-radius: 8px;
            padding: 0.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;

            i {
                color: #fff;
                font-size: 2rem;
            }
        }

        .text-container {
            .title {
                font-weight: bold;
                font-size: 1.5rem;
                color: #002855;
            }

            .description {
                font-size: 1rem;
                color: #666;
            }
        }
    }

    .content {
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 700px;

        .form-group {
            padding: 2rem;

            .form-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;

                h2 {
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #1f224f;
                }

                .public-form {
                    display: flex;
                    align-items: center;
                    background-color: #f0f8e6;
                    border: 1px solid #b2d8a6;
                    color: #61a63a;
                    border-radius: 16px;
                    padding: 0.5rem 1rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                    cursor: pointer;
                    transition: background-color 0.3s;

                    .icon {
                        font-size: 1rem;
                        margin-right: 0.5rem;
                    }

                    &:hover {
                        background-color: #d6ebd1;
                    }
                }

                .settings-container {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    color: #4285f4;

                    .settings-icon {
                        font-size: 1.5rem;
                        margin-right: 0.25rem;
                    }

                    .settings-text {
                        font-size: 1rem;
                        font-weight: bold;
                    }
                }
            }

            .link-group {
                display: flex;
                flex-direction: column;
                gap: 1rem;

                .link-input {
                    display: flex;
                    align-items: center;
                    background-color: #f3f3fc;
                    border: 1px solid #dcdcdc;
                    border-radius: 8px;
                    padding: 0.5rem 1rem;

                    .icon {
                        font-size: 1.25rem;
                        color: #9b9b9b;
                        margin-right: 0.5rem;
                    }

                    input {
                        flex: 1;
                        border: none;
                        background: none;
                        color: #7c7c7c;
                        font-size: 1rem;
                        padding: 0.5rem 0;

                        &:focus {
                            outline: none;
                        }
                    }

                    .edit-icon, .refresh-icon {
                        font-size: 1.25rem;
                        color: #9b9b9b;
                        cursor: pointer;
                        margin-left: 0.5rem;
                    }
                }

                .buttons {
                    display: flex;
                    gap: 1rem;

                    button {
                        flex: 1;
                        padding: 0.75rem;
                        font-size: 1rem;
                        font-weight: bold;
                        border-radius: 8px;
                        cursor: pointer;
                        transition: background-color 0.3s;

                        &.copy-link {
                            background-color: #4caf50;
                            color: white;
                            border: none;

                            &:hover {
                                background-color: #43a047;
                            }
                        }

                        &.open-new-tab {
                            background-color: #1976d2;
                            color: white;
                            border: none;

                            &:hover {
                                background-color: #1565c0;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
